var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "customer-container" },
    [
      _c("b-container", { attrs: { fluid: "" } }, [
        _c(
          "div",
          { staticClass: "main-content" },
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { staticClass: "text-center", attrs: { md: "3" } },
                  [
                    _c(
                      "div",
                      { staticClass: "avatar" },
                      [_c("Avatar", { attrs: { avatar: _vm.avatar } })],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { md: "5" } },
                  [
                    _vm.step === 0
                      ? _c("Step0", { on: { continue: _vm.goToNextStep } })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.step === 1
                      ? _c("Step1", {
                          attrs: { title: _vm.steps[_vm.step - 1].text },
                          on: { input: _vm.doPreAmountCalculation },
                          model: {
                            value: _vm.step1Data,
                            callback: function($$v) {
                              _vm.step1Data = $$v
                            },
                            expression: "step1Data"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.step === 2
                      ? _c("Step2", {
                          attrs: { title: _vm.steps[_vm.step - 1].text },
                          on: { input: _vm.doPreAmountCalculation },
                          model: {
                            value: _vm.step2Data,
                            callback: function($$v) {
                              _vm.step2Data = $$v
                            },
                            expression: "step2Data"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.step3Eligible && _vm.step === 3
                      ? _c("Step3", {
                          attrs: {
                            title: _vm.steps[_vm.step - 1].textProvider(
                              _vm.textProviderData
                            ),
                            "career-level-eligible": _vm.careerLevelEligible,
                            "organisational-area-eligible":
                              _vm.organisationalAreaEligible,
                            functions: _vm.step1Data.functions
                          },
                          model: {
                            value: _vm.step3Data,
                            callback: function($$v) {
                              _vm.step3Data = $$v
                            },
                            expression: "step3Data"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.step === _vm.realStep4
                      ? _c("Step4", {
                          attrs: { title: _vm.steps[_vm.step - 1].text },
                          model: {
                            value: _vm.step4Data,
                            callback: function($$v) {
                              _vm.step4Data = $$v
                            },
                            expression: "step4Data"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.step === _vm.realStep5
                      ? _c("Step5", {
                          attrs: { title: _vm.steps[_vm.step - 1].text },
                          model: {
                            value: _vm.step5Data,
                            callback: function($$v) {
                              _vm.step5Data = $$v
                            },
                            expression: "step5Data"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.step === _vm.realStep6
                      ? _c("Step6", {
                          attrs: {
                            title: _vm.steps[_vm.step - 1].text,
                            "career-level-eligible": _vm.careerLevelEligible,
                            "organisational-area-eligible":
                              _vm.organisationalAreaEligible,
                            "form-data": {
                              step1: _vm.step1Data,
                              step2: _vm.step2Data,
                              step3: _vm.step3Data,
                              step4: _vm.step4Data,
                              step5: _vm.step5Data
                            }
                          }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c("b-col", { attrs: { md: "4" } }, [
                  _c("div", { staticClass: "right-area" }, [
                    _vm.step > 1
                      ? _c(
                          "ul",
                          { staticClass: "steps" },
                          _vm._l(_vm.steps, function(loopStep) {
                            return !loopStep.hideInNav
                              ? _c(
                                  "li",
                                  {
                                    key: loopStep.number,
                                    class: {
                                      step: true,
                                      active: _vm.step === loopStep.number,
                                      done: _vm.step > loopStep.number
                                    }
                                  },
                                  [
                                    _vm.step > loopStep.number &&
                                    !_vm.isLastStep
                                      ? [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "step-link",
                                              attrs: { href: "#" },
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  _vm.step = loopStep.number
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "step-number" },
                                                [
                                                  _c("Icon", {
                                                    attrs: { icon: "checkmark" }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "step-text" },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm.getStepTitle(
                                                          loopStep
                                                        )
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      : [
                                          _c(
                                            "span",
                                            { staticClass: "step-number" },
                                            [
                                              _vm.step > loopStep.number
                                                ? _c("Icon", {
                                                    attrs: { icon: "checkmark" }
                                                  })
                                                : _c("span", [
                                                    _vm._v(
                                                      _vm._s(loopStep.number)
                                                    )
                                                  ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "step-text" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getStepTitle(loopStep)
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                  ],
                                  2
                                )
                              : _vm._e()
                          }),
                          0
                        )
                      : _vm._e()
                  ])
                ])
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _vm.step > 0 && !_vm.isLastStep
          ? _c(
              "div",
              { staticClass: "continue" },
              [
                _c(
                  "a",
                  {
                    class: ["to-next-step", { disabled: !_vm.canContinue }],
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.goToNextStep.apply(null, arguments)
                      }
                    }
                  },
                  [
                    _vm._v("\n\t\t\t\tWeiter\n\t\t\t\t"),
                    _c(
                      "span",
                      { staticClass: "to-next-step-icon" },
                      [_c("Icon", { attrs: { icon: "caret-right" } })],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "current-step" }, [
                  _vm._v(_vm._s(_vm.step))
                ]),
                _vm._v(" "),
                _vm._l(_vm.previousSteps, function(previousStep, i) {
                  return _c(
                    "a",
                    {
                      key: "previous-step-" + previousStep,
                      class: "previous-step index-" + i,
                      attrs: { href: "#" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.goToStep(previousStep)
                        }
                      }
                    },
                    [_vm._v("\n\t\t\t\t" + _vm._s(previousStep) + "\n\t\t\t")]
                  )
                })
              ],
              2
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }